import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bandit-list',
		path: '/admin/bandits',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_bandit_list" */ './index'), {
			exportName: 'AdminBanditList',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
